import { DevicesProvider } from "./../../providers/devices/devices";
import { TasksProvider } from "./../../providers/tasks/tasks";
import { Component, ChangeDetectorRef } from "@angular/core";
import {
  NavController,
  NavParams,
  ActionSheetController,
  AlertController,
  Platform,
} from "ionic-angular";
import { TaskQL, Task } from "../../providers/tasks/models";
import { ProvidersProvider } from "../../providers/providers/providers";
import { Provider } from "../../providers/providers/models";
import { UtilsProvider } from "../../providers/utils/utils";

import { TaskData } from "./../../providers/tasks/models";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { SupportPage } from '../support/support';
import { TaskCodePage } from "../task-code/task-code";
import { TaskTestPage } from "../task-test/task-test";
import { TaskCompletePage } from "../task-complete/task-complete";
import { TaskTestSecurityPage } from "../task-test-security/task-test-security";
import { TaskTestFirealarmPage } from "../task-test-firealarm/task-test-firealarm";
import { getValue } from "../../providers/tasks/filters";
import { AuthProvider } from "../../providers/auth/auth";
import { TaskQuestionsPage } from "../task-questions/task-questions";

@Component({
  selector: "page-tasks",
  templateUrl: "tasks.html",
})
export class TasksPage {
  public tasks;
  public isloading: boolean = false;
  private updateTask: any;
  private currentTasks: TaskQL[];
  private futureCollapsed: boolean = true;
  public task: TaskQL;
  private customer: any;
  public taskData: TaskData;
  public deviceStateLoading: boolean = false;
  public loading: boolean = true;
  public deviceReplace: any = false;
  private isRepair: boolean = false;
  public addressConfirmed: boolean = false;
  public showCompleteForceButton: boolean = false;
  public showCompleteForceCount: number = 0;
  repairReason: string;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private providersProvider: ProvidersProvider,
    private utilsProvider: UtilsProvider,
    private iab: InAppBrowser,
    private plt: Platform,
    private authProvider: AuthProvider
  ) {
    this.isloading = false;
    this.updateTask = this.navParams.get("updateTask");
    this.navParams.data.updateTask = null;

    this.task = this.navParams.get("task");
    this.getRepairReason();
  }

  getRepairReason(){
    if(this.task && this.task.type === 'repair' && this.task.notes && this.task.notes.length > 0){
      let noteTime, noteObj;
      this.task.notes.forEach(note => {
        if(!noteTime || noteTime > note.timestamp){
          noteTime = note.timestamp;
          noteObj = note;
        }
      });
      this.repairReason = noteObj.note;
    }
  }
  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.utilsProvider.checkVersion();
    this.initTasks();
    this.replaceControlerHandle();
  }

  completeForceCheck(){

    if(!this.showScanButton()) return
    this.showCompleteForceCount++;

    if(this.showCompleteForceCount > 10){
      this.showCompleteForceButton = true;
    }
  }

  initTasks(event?) {
    // updateTask
    if (event) {
      this.currentTasks = [];
    }
    const taskTodo = sessionStorage.getItem('taskSnn');

    let filter:any = {
      status: {
        _in: [Task.StatusEnum.Unscheduled, Task.StatusEnum.Scheduled, Task.StatusEnum.Inprogress],
        _nin: [Task.StatusEnum.Closed],
      },
    }
    if(taskTodo) {
      filter = { ...filter,...{id: {_eq: taskTodo}}}
    }

    this.tasksProvider
      .getTasks({
        limit: 1000,
        filters: filter,
      },false)
      .subscribe((data) => {
        const todayEnd = new Date();
        todayEnd.setHours(23);
        todayEnd.setMinutes(59);
        todayEnd.setSeconds(59);
        const tasks = data.items;

        if (tasks.length > 0) {
          this.currentTasks = tasks.filter((itm) => {
            return itm.assignedDate <= todayEnd.getTime();
          });
          if (this.currentTasks.length === 0)
            this.currentTasks = tasks.filter((itm) => {
              return true;
            });
          if (this.currentTasks) {
            this.task = this.currentTasks[0];
            this.openTask(this.currentTasks[0]);
          }

          if (this.updateTask) {
            const redirTask = this.tasks.filter((tsk) => {
              return tsk.id === this.updateTask.id;
            })[0];

            if (redirTask) {
              this.openTask(redirTask);
            }
          }

          this.cd.detectChanges();
          this.isloading = true;
          if (event) event.complete();

          if (this.task) {
            this.taskData = this.tasksProvider.getTaskData(this.task.id);
            this.isRepair = this.task.type.toLowerCase() == "repair";

            if (this.taskData.deviceReplace){
              this.deviceReplace = this.taskData.deviceReplace;
            }
            this.loading = false;

            if (
              this.task.deviceType === Task.DeviceTypeEnum.FireAlarm &&
              this.task.type === "repair"
            ) {
              // only on firealarm repairs
              this.deviceReplace = true;
              this.updateReplace();
              if (!this.taskData.testrepair) {
                this.tasksProvider
                  .updateTaskData(this.task, "testrepair", "error")
                  .subscribe((data) => {
                    // done
                    this.taskData = this.tasksProvider.getTaskData(
                      this.task.id
                    );
                  });
              }
            }
          }
          this.checkCode();
        } else {
          this.loading = false;
          this.isloading = true;
          this.cd.detectChanges();
        }
      });
  }

  expandCollapse() {
    this.futureCollapsed = !this.futureCollapsed;
  }

  doRefresh(event) {
    this.initTasks(event);
  }

  openTask(task) {
    const cacheTask = JSON.parse(JSON.stringify(task));
    this.tasksProvider.setSelectedTask(cacheTask);
    this.getRepairReason();
  }

  shortAddress(address) {
    return address.split(",").slice(0, 2);
  }

  ngOnChanges() {
    // console.log("Model changed!!:", this.deviceReplace);
  }

  updateReplace() {
    this.tasksProvider
      .updateTaskData(this.task, "deviceReplace", this.deviceReplace)
      .subscribe((data) => {
        this.cd.markForCheck()
        if (this.deviceReplace) {
          // remove the test if device has to be replaced
          // this.tasksProvider
          //   .updateTaskData(this.task, 'test', null)
          //   .subscribe(data => {});
        }
      });

    this.checkCode();
  }

  checkCode() {
    let code;
    let test;
    if (this.isRepair && this.taskData.verified) {
      console.log("1::::", this.deviceReplace);
      if (this.deviceReplace) {
        console.log("2:::: Do nothing, replace", this.deviceReplace);
      } else {
        console.log("3::::", this.deviceReplace);
        code =
          this.taskData.testrepair && this.taskData.testrepair !== "error"
            ? this.taskData.verified
            : null;
        test =
          this.taskData.testrepair && this.taskData.testrepair !== "error"
            ? this.taskData.testrepair
            : null;
        this.taskData.code = code;
        this.taskData.test = test;
        console.log("5::::", this.taskData.code, this.taskData.test);
        this.tasksProvider
          .updateTaskData(this.task, "code", code)
          .subscribe((data) => {
            this.tasksProvider
              .updateTaskData(this.task, "test", test)
              .subscribe((data) => {
                console.log("6::::", this.taskData);
              });
          });
      }
    }
  }

  fireAlarmRepair() {
    return (
      this.task.deviceType === Task.DeviceTypeEnum.FireAlarm &&
      this.task.type === "repair"
    );
  }

  getProviderName(id) {
    return this.utilsProvider.groupSnnToName(id);
  }


  getDeviceType(task: TaskQL) {
    return this.devicesProvider.getDeviceTypeLabel(task.deviceType);
  }

  hasAllPhotos() {
    if (
      this.task &&
      this.task.deviceType &&
      this.taskData &&
      this.taskData.photos
    ) {
      const count = this.taskData.photos.filter(
        (task) => task.data && task.data !== null
      );
      const device = this.task.deviceType;
      return device === "geyser" ? count.length > 4 : count.length > 3;
    }
    return false;
  }

  deviceControls(evt: Event, serial) {
    // const serial = type === 'codereplace'
    //   ? this.devicesProvider.getSerial(this.taskData.verified)
    //   : this.devicesProvider.getSerial(this.taskData.code);
    evt.preventDefault();
    evt.stopPropagation();

    // const module = this.task.deviceType === Task.DeviceTypeEnum.Geyser ? ControlsGeyserPage : ControlsGeyserPage;
    // if (module) {
    //   this.navCtrl.push(module, {
    //     task: this.task,
    //     serial: serial
    //   });
    // }
  }

  openModule(type) {
    let module;
    let extras = { isrepair: false, isreplace: false };
    const testController =  this.getTestController();

    switch (type) {
      case 'questions':
        module = TaskQuestionsPage;
        break;
      case "code":
        module = TaskCodePage;
        break;
      case "coderepair":
        module = TaskCodePage;
        extras = { isrepair: true, isreplace: false };
        break;
      case "codereplace":
        module = TaskCodePage;
        extras = { isrepair: false, isreplace: true };
        break;
      case "test":
        module = testController;
        break;
      case "support":
        module = SupportPage;
        break;
      case "testrepair":
        module = testController;
        extras = { isrepair: true, isreplace: false };
        break;
      default:
        break;
    }

    if (this.taskData && !this.taskData.code && type !== "code") return;

    if (module) {
      this.navCtrl.push(module, {
        task: this.task,
        customer: this.customer,
        extras,
      });
    }
  }

  getTestController(){
    if(!this.task) return;

    const testController =
      this.task.deviceType === Task.DeviceTypeEnum.Security
        ? TaskTestSecurityPage
        : this.task.deviceType === Task.DeviceTypeEnum.FireAlarm
        ? TaskTestFirealarmPage
        : TaskTestPage;
    return testController;
  }

  openMap() {
    let lat = this.task.address.latitude;
    let lng = this.task.address.longitude;
    let latlng = lat + ',' + lng;
    let url = '';
    if (!this.plt.is('cordova')) {
      url = 'https://maps.google.com/?q=' + latlng;
    } else if (this.plt.is('ios')) {
      url = 'http://maps.apple.com/maps?ll=' + latlng;
    } else if (this.plt.is('android') || this.plt.is('windows')) {
      url = 'geo:?q=' + latlng;
    }
    this.iab.create(url, '_system', 'location=true');
  }

  getPreInstallTemp(done) {
    const params = {
      limit: 10,
      filters: {
        service: { _eq: this.task.service },
        _and: { type: { _eq: "installation" } },
      },
    };
    this.tasksProvider.getTasks(params, false).subscribe((data) => {
      let tasks = getValue(data, "items");
      if (tasks) {
        const taskItem = tasks.filter(
          (task) =>
            task && task.install && task.install.serial === this.taskData.code
        );
        let question = getValue(taskItem, "0.install.questionsAnswers");
        question = question
          ? question.find((q) => q.question.includes("original thermostat"))
          : null;
        question ? done(question.answer) : done(false);
      } else {
        done(false);
      }
    });
  }

  complete_force() {
    this.addressConfirmed = true;
    this.tasksProvider.updateToInprog(this.task).subscribe( resp => {
      this.navCtrl.push(TaskCompletePage, {
        task: this.task,
      });
    },err => {
      console.log('err',err);
    })
  }

  complete() {
    // TODO
    if (!this.taskData.test) return;

    let serial = this.taskData.code;

    if (this.taskData.newSerial) serial = this.taskData.newSerial;

    if (
      serial &&
      serial.includes("GEYSER") &&
      this.task.type === "installation"
    ) {
      this.deviceStateLoading = true;
      this.devicesProvider
        .getDeviceInfo(this.taskData.code)
        .subscribe((result) => {
          this.deviceStateLoading = false;
          const signalRssi =
            result &&
            result.state &&
            result.state.reported &&
            result.state.reported.signalRssi
              ? result.state.reported.signalRssi
              : 0;

          if (signalRssi < 5) {
            let alert = this.alertCtrl.create({
              title: "Alert",
              message:
                "Rssi signal strength is " +
                signalRssi +
                ". Please fit an external aerial and re-test.",
              buttons: ["OK"],
            });
            alert.present();
          } else {
            this.navCtrl.push(TaskCompletePage, {
              task: this.task,
            });
          }
        });
    } else if (
      serial &&
      serial.includes("GEYSER") &&
      this.task.type === "deinstallation"
    ) {
      this.getPreInstallTemp((temp) => {
        if (temp) {
          let alert = this.alertCtrl.create({
            title: "Alert",
            message:
              "Please set device temperature back to " +
              temp +
              " after deinstallation.",
            buttons: ["OK"],
          });
          alert.present();
        }
        this.navCtrl.push(TaskCompletePage, {
          task: this.task,
        });
      });
    } else {
      this.navCtrl.push(TaskCompletePage, {
        task: this.task,
      });
    }
  }

  isValid() {
    let flag = false;

    if (this.taskData) {
      if (
        (this.taskData.photos &&
          this.taskData.questions &&
          this.taskData.code) ||
        (this.taskData.code && this.taskData.code.includes("FIRE"))
      ) {
        if (!this.taskData.test) {
          // replace and deinstall dont need to be tested
          if (
            this.task.type === "replace" ||
            this.task.type === "deinstallation"
          )
            flag = true;
        } else {
          flag = true;
        }
      }
    }
    return flag;
  }

  addressConfirm() {

    this.addressConfirmed = true;
  }

  showScanButton() {
    if (this.taskData && !this.taskData.code) return true;
    return false;
  }
  questionDisableCheck(){
    if(this.task && this.task.type === 'repair' && this.task.deviceType === 'geyser' && this.taskData){
      return !this.taskData.verified;
    }
    return !(this.taskData && this.taskData.code)
  }

  showRepairButtons(){
    if(this.task.type === 'repair' && this.taskData && this.taskData.code && this.task.deviceType !== 'firealarm'){
      return true
    }
    return false
  }
  showQuestionButton(){
    const showRepair = this.showRepairButtons();
    if(showRepair && this.deviceReplace && !this.taskData.newSerial) return false

    return showRepair && this.taskData && !this.taskData.questions
  }
  showTestButton() {
    if(this.task.type === 'repair'){
      if (this.taskData && !this.taskData.questions) return false;
    }
    if (this.taskData && this.taskData.test) return false;
    if (this.taskData && this.taskData.code) return true;
    return false;
  }

  showNewScanButton(){
    return this.task.type == 'repair' && this.deviceReplace && this.taskData && !this.taskData.newSerial
  }
  showCompleteButton() {
    if (this.taskData && this.taskData.test) return true;
    return false;
  }

  showReplaceToggle(){
    const showReplace = this.showRepairButtons();
    return showReplace && !this.taskData.newSerial && this.taskData && !this.taskData.test
  }
  reload(){
    this.authProvider.logoutUser();

    setTimeout(() => {
      window.location.reload();
    },500)
  }

  replaceControlerHandle(){
    const replace = getValue(this.navParams,'data.fromTest.replace');
    if(replace){
      this.deviceReplace = true;
      this.addressConfirmed = true;
      this.updateReplace();
      if(this.taskData && this.taskData.questions && this.taskData.questions.length === 1){
        // this.taskData.questions = null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks/tasks.ts